import React, {memo, useEffect} from "react";

import { Viewer, Worker } from '@react-pdf-viewer/core';

import { Typography, Modal } from '@mui/material';
import '@react-pdf-viewer/core/lib/styles/index.css';

import ButtonMain from "../button/Button_main";
import './Modal_style.scss';

const ModalPdfView = (props) => {

    useEffect(()=>{
        console.log('*****', props)
    },[props])


    return(
            <Modal
                open={props.openPdfView}
               // onClose={()=>props.setOpenJobView(false)}
                aria-labelledby="modal-modal-title"
            >
                <div className="modal-container modal-view pdf-view">
                    <Typography id="modal-modal-title" variant="textheader3" component="div">
                        Preview
                    </Typography>
                    <div className="border-bottom-modal mb-5-modal"></div>
                    <div className="mb-5-modal modal-max-h-60vh">
                        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                            <div style={{ height: '60vh' }}>
                              
                                <Viewer
                                    fileUrl={props.cVLink ? props.cVLink: null}
                                />
      
                            </div>
                        </Worker>
                    </div>
                    <div className="modal-footer-right mt-5-modal pt-5-modal border-top-modal">
                        <ButtonMain 
                            variant='primaryOutline' 
                            type='button' 
                            disabled={false} 
                            name='Cancel'
                            class='modal-capitalize'
                            onClick={()=>props.setOpenPdfView(false)}
                        />
                    </div>
                </div>
            </Modal>
    )
}

export default memo(ModalPdfView);